module.exports = __webpack_public_path__ + "img/base.8f0f67ec.png";